module.exports = __webpack_public_path__ + "img/image-6.0ee40589.jpg";